// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XU0U","questions":"styles_questions__1F25d","footer":"styles_footer__26WPY"};